import moment from 'moment';
import type {GridActionsColDef, GridColDef} from '@mui/x-data-grid';
import type {ContactNote} from 'api/v2';
import {DATE_FORMAT_LONG} from '../../constants';
import {CopyNarrativeAction} from './CopyNarrativeAction';
import {NoteCell} from './NoteCell';
import {ViewDetailsAction} from './ViewDetailsAction';
import {getServiceCodeLabel} from './utils';

// Sortable fields must match the API's ordering keys
const dateOfService: GridColDef<ContactNote> = {
  field: 'dateOfService',
  headerName: 'Date of service',
  flex: 1,
  minWidth: 130,
  valueFormatter: ({value}) => moment(value).format(DATE_FORMAT_LONG),
};

const member: GridColDef<ContactNote> = {
  field: 'member',
  headerName: 'Member',
  flex: 1,
  minWidth: 150,
  valueGetter: ({row}) => row.member.name,
};

const staff: GridColDef<ContactNote> = {
  field: 'staff',
  headerName: 'Support Staff',
  flex: 1,
  minWidth: 150,
  valueGetter: ({row}) => row.staff.name,
};

const serviceCode: GridColDef<ContactNote> = {
  field: 'serviceCode',
  headerName: 'Service code',
  flex: 0.5,
  minWidth: 120,
  // Only three values, so a filter serves better than sorting
  sortable: false,
  valueGetter: ({row}) => getServiceCodeLabel(row),
};

const note: GridColDef<ContactNote> = {
  field: 'note',
  headerName: 'Note',
  flex: 1,
  sortable: false,
  renderCell: ({row}) => <NoteCell note={row} />,
};

const actions: GridActionsColDef<ContactNote> = {
  field: 'actions',
  headerName: 'Actions',
  type: 'actions',
  maxWidth: 90,
  getActions: ({row}) => [
    <ViewDetailsAction key="viewDetails" note={row} showInMenu />,
    <CopyNarrativeAction
      key="copyNarrative"
      narrative={row.narrative}
      showInMenu
    />,
  ],
};

// Module constants keep the grid from rebuilding its columns on each render
export const NOTE_LIST_COLUMNS = [
  dateOfService,
  member,
  staff,
  serviceCode,
  actions,
];

export const COMPACT_NOTE_LIST_COLUMNS = [note, actions];
